import { render, staticRenderFns } from "./goodsClassifyList.vue?vue&type=template&id=1b0b3054&"
import script from "./goodsClassifyList.vue?vue&type=script&lang=js&"
export * from "./goodsClassifyList.vue?vue&type=script&lang=js&"
import style0 from "./goodsClassifyList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports